<template>
    <div class="app-container mt-5">
        <div class="page-title mb-3">
            <router-link to="/configuration">
                <span class="breadcrumb-link">
                    <v-icon class="breadcrumb-link-icon">settings</v-icon> Configuration du compte
                </span>
            </router-link>
            <v-icon>keyboard_arrow_right</v-icon>
            <span class="breadcrumb-item">
                <v-icon class="breadcrumb-item-icon">notifications</v-icon> Mes notifications Uska
            </span>
        </div>

        <div class="row">
            <div class="col-3">
                <v-alert text class="mb-5">
                  Paramétrez ici vos notifications par e-mail, concernant les demandes de mise à jour avec Uska.<br>
                  Choisissez une liste de socio-professionnels, que vous pouvez définir à partir de vos sélections Apidae, ou de filtres, et renseignez l'e-mail qui sera notifié.<br>
                  Vous serez notifié dès lors que vos socio-profesionnels mettront à jour leurs informations sur leur compte Uska, via le formulaire ouvert.
                </v-alert>
            </div>
            <div class="col">
                <v-card class="p-4">
                    <div class="d-flex mb-5">
                        <v-btn outlined class="custom-button-primary" @click="prepareAddModale">
                            <v-icon left>add</v-icon> Ajouter une notification
                        </v-btn>
                    </div>

                    <div v-if="notifications.length">
                        <v-data-table :headers="headers" :items="notifications" :loading="loading" class="border" :footer-props="{
                            itemsPerPageAllText: 'Toutes',
                            itemsPerPageText: 'Notifications par page',
                            itemsPerPageOptions: [10, 20, 50, 100]
                        }">
                            <template v-slot:item.name="{ item }">
                                <a @click="prepareOpenEditModal(item)">{{ item.name }}</a>
                            </template>
                            <template v-slot:item.actions="{ item }">
                                <v-btn small icon color="error" @click="deleteNotification(item)">
                                    <v-icon>delete</v-icon>
                                </v-btn>
                            </template>
                        </v-data-table>
                    </div>

                    <div v-else class="text-center">
                        <small>Aucune notification n'a été ajoutée pour le moment</small>
                    </div>

                </v-card>
            </div>
        </div>

        <v-dialog v-model="editModal" persistent max-width="600px">
            <v-card v-if="selectedNotification !== null">
                <v-card-title>
                    <span class="headline">Modification d'une notification</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field background-color="white" label="Nom" v-model="notificationName" outlined>
                    </v-text-field>

                    <v-text-field background-color="white" label="E-mail" v-model="notificationEmail" outlined>
                    </v-text-field>

                    <hr>

                    <h5>Filtres</h5>

                    <v-select label="Tag" outlined chips v-model="selectedTags" :items="tags"
                              no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                              item-text="name" multiple :disabled="tags.length == 0">
                    </v-select>

                    <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                              v-model="selectedCategories" item-value="id" item-text="label"
                              multiple :disabled="categories.length == 0">
                    </v-select>

                    <v-select label="Commune" outlined chips small-chips deletable-chips :items="communes"
                              v-model="selectedCommunes" item-value="id" item-text="label" multiple
                              :disabled="communes.length == 0">
                    </v-select>

                    <div class="d-flex justify-content-center" v-if="account.tis_type.code === 'APIDAE'">
                        <strong class="text-primary my-4">ou</strong>
                    </div>

                    <v-select label="Sélection Apidae" outlined v-if="account.tis_type.code === 'APIDAE'"
                              :items="apidaeSelections" v-model="selectedApidaeSelection"
                              return-object item-text="libelle.libelleFr" :disabled="apidaeSelections.length == 0">
                    </v-select>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <div class="w-100 text-left mb-4 ml-4">
                        <v-btn color="error" @click="editModal = false">Annuler</v-btn>
                    </div>

                    <div class="w-100 text-right mb-4 mr-4">
                        <v-btn color="primary" @click="updateNotification"
                            :disabled="!hasValidForm">
                          Enregister
                        </v-btn>
                    </div>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="addModal" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Ajout une notification</span>
                </v-card-title>

                <v-card-text>
                    <v-text-field background-color="white" label="Nom" v-model="notificationName" outlined>
                    </v-text-field>

                    <v-text-field background-color="white" label="E-mail" v-model="notificationEmail" outlined>
                    </v-text-field>

                    <hr>

                    <h5>Filtres</h5>

                    <v-select label="Tag" outlined chips v-model="selectedTags" :items="tags"
                              no-data-text="Aucun tag n'a encore été créé" small-chips deletable-chips item-value="id"
                              item-text="name" multiple :disabled="tags.length == 0">
                    </v-select>

                    <v-select label="Catégorie" outlined chips small-chips deletable-chips :items="categories"
                              v-model="selectedCategories" item-value="id" item-text="label"
                              multiple :disabled="categories.length == 0">
                    </v-select>

                    <v-select label="Commune" outlined chips small-chips deletable-chips :items="communes"
                              v-model="selectedCommunes" item-value="id" item-text="label" multiple
                              :disabled="communes.length == 0">
                    </v-select>

                    <div class="d-flex justify-content-center" v-if="account.tis_type.code === 'APIDAE'">
                      <strong class="text-primary my-4">ou</strong>
                    </div>

                    <v-select label="Sélection Apidae" outlined v-if="account.tis_type.code === 'APIDAE'"
                              :items="apidaeSelections" v-model="selectedApidaeSelection"
                              return-object item-text="libelle.libelleFr" :disabled="apidaeSelections.length == 0">
                    </v-select>

                    <div class="d-flex justify-content-end gap-10">
                        <v-btn @click="addModal = false">Annuler</v-btn>
                        <v-btn class="default-button custom-button-primary" @click="addNotification"
                            :disabled="!hasValidForm">Ajouter
                        </v-btn>
                    </div>
                </v-card-text>
            </v-card>
        </v-dialog>

        <confirm ref="confirm"></confirm>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex"
import Confirm from "../../tools/Confirm"

export default {
    name: "UskaNotificationConfig",
    components: { Confirm },
    data() {
        return {
            loading: false,
            notifications: [],
            editModal: false,
            addModal: false,
            notificationName: null,
            notificationEmail: null,
            selectedCategories: [],
            selectedTags: [],
            selectedCommunes: [],
            selectedApidaeSelection: null,
            headers: [
                {
                    text: 'Nom',
                    value: 'name'
                },
                {
                    text: 'E-mail',
                    value: 'email'
                },
                {
                    text: '',
                    value: 'actions'
                },
            ],
            selectedNotification: null
        }
    },
    methods: {
        prepareAddModale() {
            this.addModal = true
            this.notificationEmail = null
            this.notificationName = null
            this.selectedCategories = []
            this.selectedTags = []
            this.selectedCommunes = []
            this.selectedApidaeSelection = null
        },
        getNotifications() {
            this.$http.get('auth/notification-subscriptions').then(res => {
                this.notifications = res.body.data.subscriptions
            })
        },
        prepareOpenEditModal(notification) {
            this.selectedNotification = JSON.parse(JSON.stringify(notification))

            this.notificationName = this.selectedNotification.name
            this.notificationEmail = this.selectedNotification.email
            this.selectedTags = this.selectedNotification.tags.map(tag => tag.id)
            this.selectedCommunes = this.selectedNotification.communes.map(commune => commune.id)
            this.selectedCategories = this.selectedNotification.categories.map(category => category.id)

            if (this.selectedNotification.apidae_selection) {
                this.selectedApidaeSelection = this.apidaeSelections.find(selection => selection.id === this.selectedNotification.apidae_selection.external_id)
            } else {
                this.selectedApidaeSelection = null
            }

            this.editModal = true
        },
        updateNotification() {
            let payload = {
                id: this.selectedNotification.id,
                name: this.selectedNotification.name,
                email: this.selectedNotification.email,
                apidae_selection: this.selectedApidaeSelection,
                communes: this.selectedCommunes,
                tags: this.selectedTags,
                categories: this.selectedCategories
            }

            this.$global.loading = true

            this.$http.post('auth/notification-subscriptions/update', payload).then(res => {
                this.getNotifications()

                this.$global.loading = false
                this.editModal = false
            })
        },
        addNotification() {
            let payload = {
                name: this.notificationName,
                email: this.notificationEmail,
                apidae_selection: this.selectedApidaeSelection,
                communes: this.selectedCommunes,
                tags: this.selectedTags,
                categories: this.selectedCategories
            }

            this.$global.loading = true

            this.$http.post('auth/notification-subscriptions/create', payload).then(res => {
                this.getNotifications()

                this.$global.loading = false

                this.notificationName = null
                this.addModal = false
            })
        },
        deleteNotification(notification) {
            this.$refs.confirm.open('Attention',
                'Vous allez supprimer la notification <b>' + notification.name,
                { color: 'red' }).
                then((confirm) => {
                    if (confirm) {
                        this.$global.loading = true

                        this.$http.delete('auth/notification-subscriptions/' + notification.id).then(res => {
                            this.getNotifications()

                            this.$global.loading = false
                        })
                    }
                })
        },
    },
    computed: {
        ...mapState('account', ['tags', 'categories', 'communes', 'account', 'apidaeSelections']),
        hasValidForm() {
            return this.notificationName !== null &&
                this.notificationName !== '' &&
                this.notificationEmail !== null &&
                this.notificationEmail !== '' && (
                  this.selectedTags.length > 0 ||
                  this.selectedCategories.length > 0 ||
                  this.selectedCommunes.length > 0 ||
                  this.selectedApidaeSelection !== null
              )
        }
    },
    watch: {
        selectedCategories() {
            if (this.selectedCategories.length) {
                this.selectedApidaeSelection = null
            }
        },
        selectedCommunes() {
            if (this.selectedCommunes.length) {
                this.selectedApidaeSelection = null
            }
        },
        selectedTags() {
            if (this.selectedTags.length) {
                this.selectedApidaeSelection = null
            }
        },
        selectedApidaeSelection() {
            if (this.selectedApidaeSelection !== null) {
                this.selectedCommunes = []
                this.selectedCategories = []
                this.selectedTags = []
            }
        }
    },
    created() {
        this.getNotifications()

        this.$store.dispatch('account/fetchCategories')
        this.$store.dispatch('account/fetchTags')
        this.$store.dispatch('account/fetchCommunes')
        this.$store.dispatch('account/fetchApidaeSelections')
    }
}
</script>